import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { useClassroom, useClassroomMutation } from '../../classroom/api';

/** The name on the sheet and in the toolbar; saved when the field is left or on Enter. */
export function ClassroomNameField() {
  const classroom = useClassroom();
  const rename = useClassroomMutation();
  const [draft, setDraft] = useState<string | null>(null);
  const value = draft ?? classroom.data?.name ?? '';

  const commit = () => {
    const next = value.trim();
    if (next && next !== classroom.data?.name) rename.mutate(next);
    setDraft(null);
  };

  return (
    <div className="flex flex-col gap-1 text-sm">
      <label className="flex flex-col gap-1">
        Klasnaam
        <Input
          value={value}
          maxLength={60}
          onChange={(event) => setDraft(event.target.value)}
          onBlur={commit}
          onKeyDown={(event) => event.key === 'Enter' && event.currentTarget.blur()}
          className="min-h-11"
        />
      </label>
      {rename.isError && <span role="alert">De naam is niet opgeslagen. Gebruik 1 tot 60 tekens.</span>}
    </div>
  );
}
